// Import model
import { StartEstimateSwitchItemRequest } from '../models/StartEstimateSwitchItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateSwitchItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateSwitchItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateSwitchItemRequest instance
   */
  static deserialize(json: string): StartEstimateSwitchItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateSwitchItemRequest instance
   */
  static fromObject(obj: any): StartEstimateSwitchItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateSwitchItemRequest');
    }


    const instance: StartEstimateSwitchItemRequest = {
      currentItemId: obj['currentItemId'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      source: obj['source'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateSwitchItemRequest instances
   */
  static deserializeArray(json: string): StartEstimateSwitchItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateSwitchItemRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateSwitchItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateSwitchItemRequest instance to a plain object
   */
  static toObject(instance: StartEstimateSwitchItemRequest): any {
    return {
      'currentItemId': instance.currentItemId,
      'itemId': instance.itemId,
      'source': instance.source,
    };
  }

  /**
   * Serializes an array of StartEstimateSwitchItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateSwitchItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
